import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  customerServiceReview,
  networkReview,
  billReview,
  digitalExperienceReview,
  onboardingExperienceReview,
  ThanksRating,
  selectCurrentProviderMobile,
  selectCurrentProviderMobileC,
  startRatingMobile,
  confirmReview,
  selectCurrentProviderInternet,
  startRatingInternet,
  nameNickname,
  recommendProviderReview,
  recommendProviderReviewB,
  finalWordReview,
  finalWordWithReferralCodeReview,
  finalWordWithReferralCodeReviewC,
  emailAddressReview,
  addressLocationReviews,
  addressLocationReviewsC,
} from './reviews-steps'

export const mobileReviewsScenarioA: Scenario = {
  id: 'mobile-reviews-a',
  initialStep: Steps.NAME_NICKNAME,
  type: ScenarioType.MOBILE_REVIEWS,
  version: '1',
  milestones: [
    nameNickname.id,
    selectCurrentProviderMobile.id,
    addressLocationReviews.id,
    startRatingMobile.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReview.id,
    finalWordReview.id,
    confirmReview.id,
    emailAddressReview.id,
    ThanksRating.id,
  ],
  steps: [
    nameNickname,
    selectCurrentProviderMobile,
    addressLocationReviews,
    startRatingMobile,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReview,
    finalWordReview,
    confirmReview,
    emailAddressReview,
    ThanksRating,
  ],
  weight: 0,
}

export const internetReviewsScenarioA: Scenario = {
  id: 'internet-reviews-a',
  initialStep: Steps.NAME_NICKNAME,
  type: ScenarioType.INTERNET_REVIEWS,
  version: '1',
  milestones: [
    nameNickname.id,
    selectCurrentProviderInternet.id,
    addressLocationReviews.id,
    startRatingInternet.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReview.id,
    finalWordReview.id,
    confirmReview.id,
    emailAddressReview.id,
    ThanksRating.id,
  ],
  steps: [
    nameNickname,
    selectCurrentProviderInternet,
    addressLocationReviews,
    startRatingInternet,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReview,
    finalWordReview,
    confirmReview,
    emailAddressReview,
    ThanksRating,
  ],
  weight: 0,
}

export const mobileReviewsScenarioB: Scenario = {
  id: 'mobile-reviews-b',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.MOBILE_REVIEWS,
  version: '1',
  milestones: [
    emailAddressReview.id,
    nameNickname.id,
    selectCurrentProviderMobile.id,
    addressLocationReviews.id,
    startRatingMobile.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReviewB.id,
    finalWordWithReferralCodeReview.id,
    confirmReview.id,
    ThanksRating.id,
  ],
  steps: [
    emailAddressReview,
    nameNickname,
    selectCurrentProviderMobile,
    addressLocationReviews,
    startRatingMobile,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReviewB,
    finalWordWithReferralCodeReview,
    confirmReview,
    ThanksRating,
  ],
  weight: 1,
}

export const internetReviewsScenarioB: Scenario = {
  id: 'internet-reviews-b',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.INTERNET_REVIEWS,
  version: '1',
  milestones: [
    emailAddressReview.id,
    nameNickname.id,
    selectCurrentProviderInternet.id,
    addressLocationReviews.id,
    startRatingInternet.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReviewB.id,
    finalWordWithReferralCodeReview.id,
    confirmReview.id,
    ThanksRating.id,
  ],
  steps: [
    emailAddressReview,
    nameNickname,
    selectCurrentProviderInternet,
    addressLocationReviews,
    startRatingInternet,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReviewB,
    finalWordWithReferralCodeReview,
    confirmReview,
    ThanksRating,
  ],
  weight: 1,
}

export const mobileReviewsScenarioC: Scenario = {
  id: 'mobile-reviews-c',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.MOBILE_REVIEWS,
  version: '1',
  milestones: [
    emailAddressReview.id,
    nameNickname.id,
    selectCurrentProviderMobileC.id,
    startRatingMobile.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReviewB.id,
    finalWordWithReferralCodeReviewC.id,
    addressLocationReviewsC.id,
    confirmReview.id,
    ThanksRating.id,
  ],
  steps: [
    emailAddressReview,
    nameNickname,
    selectCurrentProviderMobileC,
    startRatingMobile,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReviewB,
    finalWordWithReferralCodeReviewC,
    addressLocationReviewsC,
    confirmReview,
    ThanksRating,
  ],
  weight: 1,
}
